export default __webpack_public_path__ + "locales/it/Payments.json?hash=4fede0315287ed0525fd48e042fc1f9f";